/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
// @ts-expect-error untyped-import
import { Button } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import {
  CancelAndRTMContainer,
  HaveAnAccountLogInContainer,
  InterstitialContainer,
} from './StyledComponents';
import { HaveAnAccountLogIn } from '../../Billing/Components';
import { Link } from '@/components/Common';
import React from 'react';

type VenmoOverlayProps = {
  hasLogin?: boolean;
  onCancel?: (e: React.MouseEvent) => void;
  onContinue: () => void;
};

const VenmoOverlay = (props: VenmoOverlayProps): JSX.Element => {
  return (
    <InterstitialContainer>
      <h3>
        {getContent('valueProps.payWith.guest.venmo.noApp')}{' '}
        {getContent('valueProps.payWith.guest.venmo.continue')}
      </h3>

      <Button
        aria-label={getContent('buttons.guest.payWithPaypal')}
        onClick={props.onContinue}
      >
        {getContent('buttons.guest.base')}
      </Button>

      {props.onCancel && (
        <CancelAndRTMContainer>
          <Link
            href="#"
            onClick={props.onCancel}
            text={getContent('billing.cancelAndRTM')}
          />
        </CancelAndRTMContainer>
      )}
      {props.hasLogin && (
        <HaveAnAccountLogInContainer>
          <HaveAnAccountLogIn />
        </HaveAnAccountLogInContainer>
      )}
    </InterstitialContainer>
  );
};

export { VenmoOverlay };
